/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from 'react';
import './ShellOrg.scss';

/**
 * ShellOrg function component.
 * @param {Object} <ObjectPattern> Handler for onClick, children node to be
 * rendered, selected boolean.
 * @returns {ReactElement} Markup representing the ShellOrg component.
 */
function ShellOrg(props) {
  return (
    <div
      className="spectrum-Shell-companyLabel"
      id="spectrum-Shell-companyLabel"
      role="presentation">
      {props.children}
    </div>
  );
}
export default React.memo(ShellOrg);
